/**
 * Created by david.vanoni@coplex.com on 8/24/17.
 */

import { Helmet } from 'react-helmet-async';
import React from 'react';
import { Alert } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import AcceptInvitationFormContainer from '../containers/auth/AcceptInvitationFormContainer.jsx';

const AcceptInvitation = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const organization_slug = searchParams.get('organization_slug');

  return (
    <div className="component-centered">
      <Helmet>
        <title>ChangeSync</title>
      </Helmet>
      {token ? (
        <AcceptInvitationFormContainer
          invitationToken={token}
          organizationSlug={organization_slug}
        />
      ) : (
        <Alert bsStyle="danger">Invalid invitation token.</Alert>
      )}
    </div>
  );
};

export default AcceptInvitation;
